var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-modal"},[_c('div',{staticClass:"ed-modal__content"},[(_vm.show)?_c('div',{staticClass:"bsx-d-flex ed-modal__content__container"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }